'use strict';

var mcb = mcb || {};

mcb.video = mcb.video || new function () {

    this.init = function () {
        
        if(!document.querySelector('.video-block-player'))
        return;

        const options = {
            autoplay: false,
            autopause: 1,
            volume: 100,
            muted: false,
            storage: {enabled: false},
            poster: 'https://i.imgur.com/4Dq2n5A.jpg',
            youtube: { noCookie: true, rel: 0, showinfo: 0, iv_load_policy: 3, modestbranding: 1 },
            loop: {
                active: true
            },
            fullscreen: {
                enabled: false,
                fallback: true,
                iosNative: false,
                container: null
            }
        }

        const players = Plyr.setup('.video-block-player', options);
    };
}();
